import { styled } from "goober";
import { Skeleton } from "../../Skeleton";
import {
  COLUMN_ORDER,
  COLUMN_PITCH,
  NODE_HEIGHT,
  NODE_WIDTH,
  ROW_PITCH,
} from "./layoutGraph";

const HEADER_HEIGHT = 48;
const CANVAS_MARGIN = 24;
// Fewer rows than a populated map, so the real graph grows down into the
// skeleton when it lands rather than shrinking from it.
const ROWS_PER_COLUMN = [6, 3, 5, 3, 6];
const MAX_ROWS = Math.max(...ROWS_PER_COLUMN);

const Viewport = styled("div")`
  flex: 1;
  min-height: 0;
  position: relative;
  display: flex;
  flex-direction: column;
`;

const Scroll = styled("div")`
  flex: 1;
  overflow: hidden;
  position: relative;
`;

const HeaderBar = styled("div")`
  position: sticky;
  top: 0;
  left: 0;
  z-index: 2;
  height: ${HEADER_HEIGHT}px;
  min-width: 100%;
  background: var(--surface-secondary);
`;

const ColumnSlot = styled("div")`
  position: absolute;
  top: 0;
  height: ${HEADER_HEIGHT}px;
  display: flex;
  align-items: center;
  padding-left: 8px;
`;

const Canvas = styled("div")`
  position: relative;
  margin: ${CANVAS_MARGIN}px;
`;

// Same footprint as GraphNodeChip so the real card lands in place when the graph
// loads; each card is a plain shimmer block, matching the other monitoring panels.
const ChipShimmer = styled(Skeleton)`
  position: absolute;
  width: ${NODE_WIDTH}px;
  height: ${NODE_HEIGHT}px;
  border-radius: 12px;
`;

const CANVAS_WIDTH = (COLUMN_ORDER.length - 1) * COLUMN_PITCH + NODE_WIDTH;
const CANVAS_HEIGHT = MAX_ROWS * ROW_PITCH;

export function AccessGraphSkeleton() {
  return (
    <Viewport aria-hidden>
      <Scroll>
        <HeaderBar style={{ width: CANVAS_WIDTH + CANVAS_MARGIN * 2 }}>
          {COLUMN_ORDER.map((kind, ci) => (
            <ColumnSlot
              key={kind}
              style={{ left: CANVAS_MARGIN + ci * COLUMN_PITCH }}
            >
              <Skeleton style={{ width: 56, height: 10 }} />
            </ColumnSlot>
          ))}
        </HeaderBar>
        <Canvas style={{ width: CANVAS_WIDTH, height: CANVAS_HEIGHT }}>
          {COLUMN_ORDER.map((kind, ci) =>
            Array.from({ length: ROWS_PER_COLUMN[ci]! }, (_, row) => (
              <ChipShimmer
                key={`${kind}-${row}`}
                style={{
                  left: ci * COLUMN_PITCH,
                  top: row * ROW_PITCH,
                  opacity: Math.min(1, (MAX_ROWS - row) / 4),
                }}
              />
            ))
          )}
        </Canvas>
      </Scroll>
    </Viewport>
  );
}
